/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_SupportInputs */



/**
* | output |
* | --- |
* | "Support the site" |
*
* @param {Layout_Header_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_support = /** @type {((inputs?: Layout_Header_SupportInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_SupportInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seite unterstützen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soutenir le site")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("支持本站")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("支持本站")
	if (locale === "ko") return /** @type {LocalizedString} */ ("사이트 후원하기")
	return /** @type {LocalizedString} */ ("Support the site")
});